import { AbstractFormArgument } from './global'

class FormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.brand = ''
    this.industry = ''
    this.comAdress = ''
    this.sonCompanys = ''
    this.money = ''
    this.people = ''
    this.comBrand = ''
    this.platform = ''
    this.strategySurveyId = ''
    /* '0-首页 调查问卷，
    1-首页 马上体验，
    2-页面底部 立即提交，
    3-浮窗 大数据定制，
    4-浮窗 在线咨询，
    5-后台顶部 在线咨询，
    6-后台顶部留言，
    7-前台 我要购买 产品详情，
    8-后台 我要购买 产品详情' */
    this.type = '' /* '1-客户平台PC-官网，2-客户平台PC-后台，3-客户小程序' */
  }
}

class PhoneArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.name = ''
    this.enterpriseName = ''
    this.telephone = ''
    this.platform = ''
    this.type = ''
    this.strategySurveyId = ''
  }
}

export {
  FormArgument,
  PhoneArgument
}



// WEBPACK FOOTER //
// ./src/models/strategy-survey.js